import { render, staticRenderFns } from "./AliveIndicator.vue?vue&type=template&id=6de7b3fd&scoped=true&lang=pug&"
import script from "./AliveIndicator.vue?vue&type=script&lang=ts&"
export * from "./AliveIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./AliveIndicator.vue?vue&type=style&index=0&id=6de7b3fd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de7b3fd",
  null
  
)

component.options.__file = "AliveIndicator.vue"
export default component.exports